/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React, { useState } from "react";
import { useTranslation } from "next-i18next";
import { Form } from "components/Form";
import { IAppState, UserStore, dispatch, useSelector } from "@nf/common";
import { SettingsSubscriptionButton } from "components/Settings/SettingsSubscriptionButton/SettingsSubscriptionButton";

import styles from "./PauseSubscriptionForm.module.scss";

export interface IPauseSubscriptionFormProps {
  endDate: string;
  setIsFormSent: (value: boolean) => void;
  setIsPauseFormSent: (value: boolean) => void;
}

const PERIOD_ARRAY = [{ value: "1" }, { value: "2" }, { value: "3" }];

export const PauseSubscriptionForm = ({
  endDate,
  setIsFormSent,
  setIsPauseFormSent,
}: IPauseSubscriptionFormProps) => {
  const { t } = useTranslation("translations");
  const [selectedValue, setSelectedValue] = useState("");
  const userId = useSelector((state: IAppState) => state.auth.user?.Id);

  const onFinish = (pausePeriod: string) => {
    userId &&
      dispatch(
        UserStore.Actions.pauseSubscription(userId.toString(), pausePeriod)
      );

    setIsPauseFormSent(true);
    setIsFormSent(true);
  };

  const PeriodMapper = ({
    selectedValue,
    setSelectedValue,
  }: {
    selectedValue: string;
    setSelectedValue: (value: string) => void;
  }) => (
    <div className={styles.PeriodContainer}>
      {PERIOD_ARRAY.map((element, i) => {
        const index = `period_array_${i}`;
        const selectTranslationKey = (value: string) => {
          const selectedTranslationKey =
            value === "1"
              ? t("web_subscription_pause_month")
              : t("web_subscription_pause_months");

          return `${" "}${selectedTranslationKey}`;
        };

        return (
          <div key={index}>
            <input
              id={index}
              className="input-radio cursor-pointer"
              checked={selectedValue === element.value}
              onChange={(e) => setSelectedValue(e.target.value)}
              type="radio"
              value={element.value}
            />
            <label htmlFor={index}>
              {element.value}
              {selectTranslationKey(element.value)}
            </label>
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      <p>
        {t("web_subscription_pause_period")}
        <span className={styles.Bold}> {endDate}</span>
      </p>
      <p className={styles.ContentTite}>{t("web_subscription_pause_title")}</p>
      <p className={styles.ContentInfo}>{t("web_subscription_pause_info")}</p>
      <p>{t("web_subscription_pause_description")}</p>
      <Form onFinish={() => onFinish(selectedValue)}>
        <PeriodMapper
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
        />
        <div className={styles.ButtonContainer}>
          <SettingsSubscriptionButton
            variant="primary"
            type="submit"
            disabled={!selectedValue}
          >
            {t("web_subscription_pause_button_confirm")}
          </SettingsSubscriptionButton>
        </div>
      </Form>
    </>
  );
};
